import React from 'react';
import { Above } from '@jetshop/ui/Breakpoints';
import MaxWidth from '../Layout/MaxWidth';
import { styled } from 'linaria/react';
import { theme } from '../Theme';

const defaultCustomGallery = '60fa8a44437b2b5da86678b0';
const defaultProductGallery = '60f7cb85042fa54411c57294';
const apiKey = '7ZElgEXFPZKWgGbq1nEVydvM0pwRrMcRyGeHdC08';

const Wrapper = styled('div')`
  width: 100%;

  ${theme.above.md} {
    max-width: 1440px;
    margin: 0 auto;
    padding: 0 3.5rem;
  }

  .yotpo-slider-title-wrapper {
    text-align: left !important;
    margin-bottom: 30px !important;
    span.yotpo-slider-title {
      font-family: ${theme.fonts.primary}, ${theme.fonts.primaryFallback} !important;
      color: ${theme.colors.black};
      text-transform: uppercase;
      font-size: 1.5rem;
      font-weight: 700;
      letter-spacing: 0.03em;
      ${theme.below.md} {
        font-size: 1rem;
        padding: 0 1rem;
      }
    }
  }

  .yotpo-pictures-widget .yotpo-display-wrapper .y-arrows .arrows-wrapper-left,
  .yotpo-pictures-widget
    .yotpo-display-wrapper
    .y-arrows
    .arrows-wrapper-right {
    height: 30px;
    width: 30px;
    top: calc(50% - 15px);
    .yotpo-icon {
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 0;
      width: 100% !important;
      &:before {
        font-size: 18px;
        margin-top: 0;
        top: 0;
        left: 0;
        right: 0;
      }
    }
  }
`;

const YotpoProvider = ({ productId }) => {
  React.useEffect(() => {
    if (typeof window !== 'undefined' && typeof window.yotpo !== 'undefined') {
      window.yotpo.refreshWidgets();
    }
  }, [productId]);

  React.useEffect(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.defer = true;
    script.src = `https://staticw2.yotpo.com/${apiKey}/widget.js`;

    document.body.appendChild(script);
    return () => document.body.removeChild(script);
  }, [apiKey]);
  return null;
};

const YotpoGallery = ({ productId, galleryId }) => (
  <Wrapper>
    <YotpoProvider productId={productId} />
    {productId ? (
      <div
        class="yotpo yotpo-pictures-widget"
        data-gallery-id={galleryId ? galleryId : defaultCustomGallery}
      ></div>
    ) : (
      <div
        class="yotpo yotpo-pictures-widget"
        data-gallery-id={galleryId ? galleryId : defaultProductGallery}
        data-product-id={productId}
      ></div>
    )}
  </Wrapper>
);

export default YotpoGallery;
